<template>
  <div>
    <v-layout
      align-center
      class="mb-1">
      <v-flex shrink>
        <span class="title">Rates</span>
      </v-flex>
      <v-spacer/>
      <v-flex shrink>
        <span class="caption">
          You can manage standard rates from
          <router-link
            :to="{ name: 'priceList' }"
            class="clickable">
            Admin > Subcontractors > Standard price list
          </router-link>
        </span>
      </v-flex>
    </v-layout>
    <v-progress-linear
      v-if="loading"
      class="ma-0"
      color="grey"
      height="1"
      indeterminate/>
    <v-divider v-else/>
    <template v-if="!loading && rates.length === 0">
      <v-layout justify-center>
        <span class="subtitle">No rates defined.</span>
      </v-layout>
    </template>
    <template v-else>
      <v-expansion-panel :value="rates.length > 0 ? 0 : -1">
        <v-expansion-panel-content>
          <v-data-table
            :headers="headers"
            :items="rates">
            <template
              slot="items"
              slot-scope="props">
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.description }}</td>
              <td class="text-xs-right">{{ props.item.class }}</td>
              <td class="text-xs-right">
                <template v-if="props.item.special">
                  <v-tooltip
                    transition="v-fade-transition"
                    right>
                    <span
                      slot="activator"
                      class="red--text text--lighten-3">
                      {{ props.item.special }}
                    </span>
                    <span>Standard: {{ props.item.value }}</span>
                  </v-tooltip>
                </template>
                <template v-else>
                  {{ props.item.value }}
                </template>
              </td>
              <td class="text-xs-right">{{ props.item.unit }}</td>
              <td class="justify-center align-center layout px-0">
                <v-btn
                  class="mx-0"
                  icon
                  small
                  @click="edit(props.item.rateId)">
                  <v-icon small>edit</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </template>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="30rem">
      <v-card>
        <v-card-text>
          <v-container>
            <v-layout>
              <v-flex>
                <v-form v-model="valid">
                  <v-text-field
                    v-model="editedRate.value"
                    :rules="[
                      (v) => !!v || 'Rate is required',
                      (v) => !isNaN(parseFloat(v)) || 'Must be a number',
                      (v) => typeof v === 'string' && !isNaN(parseFloat(v)) &&
                        parseFloat(v).toFixed(2).length >= v.length ||
                        'Precision too high'
                    ]"
                    label="Rate"/>
                </v-form>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            :disabled="postingReset || postingSave"
            flat
            @click="dialog = false">
            Cancel
          </v-btn>
          <v-btn
            :disabled="postingReset || postingSave"
            flat
            @click="reset">
            <v-progress-circular
              v-if="postingReset"
              indeterminate/>
            <span v-else>Reset</span>
          </v-btn>
          <v-btn
            :disabled="!valid || postingReset || postingSave"
            flat
            @click="save">
            <v-progress-circular
              v-if="postingSave"
              indeterminate/>
            <span v-else>Save</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "rates-table",
  props: {
    rates: {
      required: true,
      type: Array
    },
    loading: {
      required: true,
      type: Boolean
    }
  },
  data () {
    return {
      defaultRate: {
        class: null,
        description: "",
        name: "",
        unit: "",
        value: null
      },
      dialog: false,
      editedRate: {
        rateId: null,
        value: null
      },
      headers: [
        {
          text: "Name",
          value: "name",
          width: "15%"
        },
        {
          text: "Description",
          value: "description"
        },
        {
          align: "center",
          text: "Class",
          value: "class",
          width: "10%"
        },
        {
          align: "center",
          text: "Rate",
          value: "value",
          width: "10%"
        },
        {
          align: "center",
          text: "Unit",
          value: "unit",
          width: "15%"
        },
        {
          align: "center",
          sortable: false,
          text: "Actions",
          value: "actions",
          width: "10%"
        }
      ],
      postingReset: false,
      postingSave: false,
      valid: false
    };
  },
  methods: {
    edit (rateId) {
      this.editedRate.rateId = rateId;
      const index = this.rates.map((rate) => rate.rateId).indexOf(rateId);
      this.editedRate.value =
        this.rates[index].special || this.rates[index].value;
      this.dialog = true;
    },
    reset () {
      this.postingReset = true;
      this.$http.
        delete(`/api/subcontractor_rates
?subcontractorId=${this.$route.params.id}
&rateId=${this.editedRate.rateId}`).
        then(() => {
          this.$emit("refresh");
          this.postingReset = false;
          this.dialog = false;
        }).
        catch(() => this.postingReset = false);
    },
    save () {
      this.postingSave = true;
      this.$http.
        post(
          `/api/subcontractor_rates
?subcontractorId=${this.$route.params.id}
&rateId=${this.editedRate.rateId}`,
          { value: this.editedRate.value }).
        then(() => {
          this.postingSave = false;
          this.$emit("refresh");
          this.dialog = false;
        }).
        catch(() => this.postingSave = false);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Subcontractor/RatesTable.vue